<template>
  <div>
    <div v-if="!nalaganje">
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">Ranking</h3>
              <a @click.prevent="showInfoModal"><i class="fa fa-info-circle"></i></a>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip"
                        title="Collapse">
                  <i class="fa fa-minus"></i></button>
              </div>
            </div>

            <div class="info-box">
              <span class="info-box-icon bg-gray-light"><i class="fa fa-trophy" style="color: #0073b7"></i></span>

              <div class="info-box-content">
                <span class="info-box-text"></span>
                <span v-if="!toggleLeaderboard" class="info-box-number">{{$t("pages.exams.ratingResults.completeMoreQuizes")}}</span>
                <span v-else class="info-box-number">{{$t("pages.exams.ratingResults.joinedLeaderboard")}}</span>
                <div v-if="!toggleLeaderboard" class="progress-leaderboard">
                  <div class="progress-bar-eighty"></div>
                  <div class="progress-bar-leaderboard" :style="'width: ' + (1-ratingDeviation/350)*100 + '%; background: #0073b7'"></div>
                </div>
                <span v-if="!toggleLeaderboard" class="progress-description">{{$t("pages.exams.ratingResults.yourRatingIsInaccurate")}} <b>75%</b></span>
                <span v-else class="progress-description">{{$t("pages.exams.ratingResults.improveRating")}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="small-box bg-blue" @click.prevent.stop="showRatingQuizSelection">
            <div class="inner">
              <h3>{{$t('pages.ratingHistory.ratingQuiz')}}</h3>
              <h4>{{$t('pages.exams.ratingResults.numberOfSolvedExercises')}}&nbsp;&nbsp;&nbsp;{{solvedExercises}}/{{allExercises}}</h4>
            </div>
            <div class="icon">
              <i class="fa fa-trophy"></i>
            </div>
            <a href="#" class="small-box-footer">{{$t('pages.ratingHistory.startQuiz')}} <i class="fa fa-arrow-circle-right"></i></a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">{{$t("pages.exams.ratingResults.leaderboard")}}</h3>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip"
                        title="Collapse">
                  <i class="fa fa-minus"></i></button>
              </div>
            </div>

            <div v-if="leaderboard.length > 0" id="leaderboard">
              <div class="ribbon"></div>
              <table>
                <tr v-for="(user, index) in leaderboard.slice(0, 6)" :key="user.username">
                  <td v-if="user.place" class="number">{{user.place + 1}}</td>
                  <td v-else class="number">{{index + 1}}</td>
                  <td v-if="user.place" class="name" style="font-weight: bold; color: #00a65a; ">{{user.username}}</td>
                  <td v-else class="name">{{user.username}}</td>
                  <td v-if="user.place" class="points" >{{user.ratingGlicko}}</td>
                  <td v-else class="points">
                    {{user.ratingGlicko}}
                    <img v-if="index == 0" class="gold-medal" src="https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true" alt="gold medal"/>
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <div style="padding: 20px; text-align: center;">
                <span>{{$t('pages.exams.ratingResults.leaderboardEmpty')}}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!dataById" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="box">
            <div class="box-header">
              <h3 class="box-title">{{$t('pages.ratingHistory.ratingHistory')}}</h3>
            </div>
            <!-- /.box-header -->

            <div id="leaderboard" style="max-height: 315px; overflow-y: auto">
              <table>
                <tbody>
                <tr class="history-cell">
                  <th>{{$t('pages.ratingHistory.date')}}</th>
                  <th colspan="2">{{$t('pages.ratingHistory.numberOfPoints')}}</th>

                  <th>{{$t('pages.ratingHistory.rating')}}</th>
                </tr>
                <tr v-for="(izpit, i) in ratingHistory.slice().reverse()" class="history-cell" @click="showResultsForOneExam(izpit.examAttemptId)">
                  <td>{{new Date(izpit.date).toLocaleString('default', { day: 'numeric', month: 'short' })}}</td>
                  <td>
                    <div class="progress progress-xs" style="width: 7rem; margin: auto 0">
                      <div v-if="izpit.points/izpit.maxPoints >= 0.75" class="progress-bar progress-bar-green" :style="{width: (100 * izpit.points / izpit.maxPoints) + '%'}"></div>
                      <div v-else-if="izpit.points/izpit.maxPoints >= 0.25"class="progress-bar progress-bar-yellow" :style="{width: (100 * izpit.points / izpit.maxPoints) + '%'}"></div>
                      <div v-else class="progress-bar progress-bar-red" :style="{width: (100 * izpit.points / izpit.maxPoints) + '%'}"></div>
                    </div>
                  </td>
                  <td>
                    <span class="badge bg-blue">{{izpit.points.toFixed(1) + '/' + izpit.maxPoints}}</span>
                  </td>
                  <td style="text-align: center; font-weight: bold">{{izpit.newRating}}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <!-- /.box-body -->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="info-box">
            <span class="info-box-icon bg-gray-light"><i class="glyphicon glyphicon-stats" style="color: #0073b7"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">{{$t('pages.ratingHistory.currentRating')}}</span>
              <span class="info-box-number" style="font-size: 30px">{{rating}}</span>
            </div>

          </div>
        </div>

        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="info-box">
            <span v-if="ratingDeviation <= 70" class="info-box-icon bg-gray-light"><i class="fa fa-bullseye" style="color: #0073b7"></i></span>
            <span v-else-if="ratingDeviation <= 180" class="info-box-icon bg-gray-light"><i class="fa fa-bullseye" style="color: #f39c12"></i></span>
            <span v-else class="info-box-icon bg-gray-light"><i class="fa fa-bullseye" style="color: #dd4b39"></i></span>

            <!--
            <span v-if="ratingDeviation <= 70" class="info-box-icon bg-green"><i class="fa fa-bullseye"></i></span>
            <span v-else-if="ratingDeviation <= 180" class="info-box-icon bg-yellow"><i class="fa fa-bullseye"></i></span>
            <span v-else class="info-box-icon bg-red"><i class="fa fa-bullseye"></i></span>
            -->

            <div class="info-box-content">
              <span class="info-box-text">{{$t('pages.exams.ratingResults.ratingAccuracy')}}</span>
              <span class="info-box-number" style="font-size: 30px">{{Math.round((1 - ratingDeviation/350) * 100)}}%</span>
            </div>

          </div>
        </div>

        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="info-box">
            <span v-if="solvedExercises/allExercises < 1" class="info-box-icon bg-gray-light"><i class="fa fa-list" style="color: #0073b7"></i></span>
            <span v-else class="info-box-icon bg-gray-light"><i class="fa fa-list" style="color: #00a65a">></i></span>

            <div class="info-box-content">
              <span class="info-box-text">{{$t('pages.exams.ratingResults.numberOfSolvedExercises')}}</span>
              <span class="info-box-number" style="font-size: 30px">{{solvedExercises}}/{{allExercises}}</span>
            </div>

          </div>
        </div>
      </div>

      <!------------------------------------------------------->
        <div class="col-md-12 col-xs-12">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">{{$t('pages.ratingHistory.graph')}}</h3>
            </div>
            <div class="box-body">
              <line-chart class="" :height="125" :options="{ scales: { yAxes: [{ ticks: {max: max, min: min} }] } }" :chartData="grafRatinga"></line-chart>
            </div>
            <!-- /.box-body -->
          </div>
        </div>

        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">{{$t('pages.adminpanel.ratingStatistics.group')}}</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div class="margin">
                <div class="">
                  <h5>{{$t('pages.adminpanel.ratingStatistics.userRatings')}}</h5>
                  <div class="row">
                    <div class="col-sm-12">
                      <Bar style="height: 20em" class="" :height="125" :chartData="{labels: ratingHistogramX,
                      datasets: [{label: $t('pages.adminpanel.ratingStatistics.numberOfStudents'), backgroundColor: ratingHistogramBarve, data: ratingHistogramY}]}"
                           :options="{maintainAspectRatio: false, responsive: true, scales: {xAxes: [{stacked: true, barPercentage: '1',  categoryPercentage: '0.9'}], yAxes: [{stacked: true}]}}"></Bar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>

      </div>

    <div class="modal modal-default fade" :id="'selectSubgroupsModal'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.ratingHistory.ratingQuiz')}}</h4>
          </div>
          <div class="modal-body">
            <span>{{$t('pages.exams.ratingResults.ratingQuizInfo')}}</span>
            <h4 class="modal-title"  style="margin: 20px 0 10px 0">{{$t('pages.subgroups.selectSubgroups')}}</h4>
            <span style="width: 100%; text-align: center;" v-if="loadingSubgroups">
              <pulse-loader :color="spinnerColor" :size="spinnerSize"></pulse-loader>
            </span>
            <template>
              <div class="form-group">
                <transition-group name="fade">
                  <div v-for="subgroup in filteredSubgroups" :key="subgroup.id">
                    <div :style="'margin-left: ' + (2 * subgroup.nivo) + 'em'">
                      <input v-if="subgroup.list" type="checkbox" :id="subgroup.id" :value="subgroup.id" v-model="izbranePodskupine">
                      <label :for="subgroup.id" @click.prevent="toggleSubgroup(subgroup)">
                        {{ !subgroup.list ? expandedSymbol(subgroup) : '' }} {{ subgroup.name | pickTranslation }}
                      </label>
                      <span
                          v-if="!subgroup.list"
                          @click.prevent="selectAllSbgroupsInTree(subgroup.id, true)"
                          class="text-light-blue pointer"
                      >
                        ({{$t('pages.subgroups.addAll')}})
                      </span>
                      <span
                          v-if="!subgroup.list"
                          @click.prevent="selectAllSbgroupsInTree(subgroup.id, false)"
                          class="text-light-blue pointer"
                      >
                        ({{$t('pages.subgroups.removeAll')}})
                      </span>
                    </div>
                  </div>
                </transition-group>
              </div>
            </template>

            <!--Izbira trajanja-->
            <div class="form-group">
              <label>{{$t('pages.subgroups.selectDuration')}}</label>
              <select class="form-control" v-model="izbranoTrajanje">
                <option value="20">20 min</option>
                <option value="30">30 min</option>
                <option value="45">45 min</option>
              </select>
            </div>

          </div>
          <div class="modal-footer">
            <button class="btn btn-primary pull-right" data-dismiss="modal" @click.prevent="startRatingQuiz">{{$t('pages.subgroups.createQuiz')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- info modal-->
    <div class="modal modal-success fade" :id="modalInfoKey" v-if="showInfoModalBoolean">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.ratingResults.infoTitle')}}</h4>
          </div>
          <div class="modal-body">
            <p>{{$t('pages.exams.ratingResults.info')}} </p>
            <p>{{$t('pages.exams.ratingResults.infoDeviation')}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.reports.close')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>

<script>
  import Rest from './../../services/rest'
  import router from './../../router/router'
  import Line from '@/charts/Line.js'
  import Bar from '@/charts/Bar.js'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import editsubgroup from '@/components/admin/group/EditSubgroup.vue'
  import createsubgroup from '@/components/admin/group/CreateSubgroup.vue'
  import orderexer from '@/components/admin/group/ExercisesInOrder.vue'
  import editRules from '@/components/admin/group/EditSubgroupRules.vue'
  import previewExer from '@/components/admin/group/ExercisesPreview.vue'
  import Pie from '@/charts/Pie'
  import Exercise from '@/components/exercises/Exercise.vue'
  import ExercisesList from '@/components/exercises/ExercisesList.vue'
  import Library from '@/components/admin/Library.vue'
  import SpiderChart from '@/components/groups/SpiderChart.vue'
  import vSelect from 'vue-select'
  import ReorderSubgroups from '@/components/admin/group/ReorderSubgroups.vue'
  import ExerciseResultsPreview from '@/components/exercises/ExerciseResultsPreview.vue'
  import ExamResultsPreview from '@/components/admin/group/ExamResultsPreview.vue'
  import {mapGetters} from 'vuex'
  import crypto from 'crypto'
  export default {
    name: 'UserRating',
    props: ['gid', 'yid', 'uid'],
    computed: {
      dataById () {
        return this.$route.name === 'UserRatingById' || this.$route.name === 'UserRatingByIdAdmin'
      },
      filteredSubgroups () {
        return this.subgroupArray.filter((subgroup) => {
          if (subgroup.expanded) {
            return true
          }
          // Display subgroups with parent set to null
          if (subgroup.parent === null) {
            return true
          }
          // Hide all other subgroups
          return false
        })
      },
      ...mapGetters({
        seznamPodskupin: 'getSubgroups',
        dnevneNaloge: 'getDailyChallenges',
        seznamKvizov: 'getExams',
        jeAdmin: 'hasAdminRole'
      })
    },
    components: {
      'line-chart': Line,
      Bar,
      'pulse-loader': PulseLoader,
      editsubgroup,
      createsubgroup,
      orderexer,
      editRules,
      previewExer,
      bar: Bar,
      pie: Pie,
      line: Line,
      'exercise': Exercise,
      'exercises-list': ExercisesList,
      'library': Library,
      'spider-chart': SpiderChart,
      'v-select': vSelect,
      'reorder-subgroups': ReorderSubgroups,
      'exercise-results-preview': ExerciseResultsPreview,
      'exam-results-preview': ExamResultsPreview
    },
    data () {
      return {
        nalaganje: true,
        rating: 1000,
        ratingDeviation: 350,
        bestRating: 1000,
        worstRating: 1000,

        ratingHistory: [],
        grafRatinga: null,
        timeAxis: null,
        min: 0,
        max: 1700,
        subgroupArray: [],
        izbranePodskupine: [],
        izbranoTrajanje: 20,
        izbranaTezavnost: 'lahko',
        spinnerColor: '#3c8dbc',
        spinnerSize: '15px',
        loadingSubgroups: false,
        histogram: {},
        ratingHistogramX: [],
        ratingHistogramY: [],
        ratingHistogramBarve: [],

        currentUser: null,
        leaderboard: [],
        toggleLeaderboard: true,

        allExercises: 0,
        solvedExercises: 0,
        showInfoModalBoolean: false,
        modalInfoKey: 'modal-info-' + this.getUniqueKey()
      }
    },
    mounted () {
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: 'root'
      })
      this.$store.commit('updateAdminBreadcrumbs', [{path: '', name: {'en-us': 'Rating', sl: 'Rating'}}])
      this.pridobiPodatke()
    },
    methods: {
      pridobiPodatke () {
        let postdata = {
          groupId: this.gid
        }
        if (this.dataById) {
          postdata['userId'] = this.uid
        }
        return Rest.request('POST', `/rating/userRatingStatistics`, postdata).then((data) => {
          this.ratingHistory = data.history
          this.histogram = data.ratingHistogramUsers
          if (this.ratingHistory.length > 0) {
            this.bestRating = this.ratingHistory[0].newRating
            this.worstRating = this.ratingHistory[0].newRating
          }
          for (let i = 1; i < this.ratingHistory.length; i++) {
            if (this.bestRating < this.ratingHistory[i].newRating) {
              this.bestRating = this.ratingHistory[i].newRating
            }
            if (this.worstRating > this.ratingHistory[i].newRating) {
              this.worstRating = this.ratingHistory[i].newRating
            }
          }
          if (this.ratingHistory.length !== 0) {
            this.rating = this.ratingHistory[this.ratingHistory.length - 1].newRating
            this.ratingDeviation = this.ratingHistory[this.ratingHistory.length - 1].newRatingDeviation
          }
          this.pripraviHistogram()
          this.pripraviGraf()
        }).catch((err) => {
          this.nalaganje = false
          console.log(err)
        })
      },
      ratingToHistogramGroup (rating) {
        let spodnjaMeja = Math.floor(rating / 100) * 100
        return spodnjaMeja + '-' + (spodnjaMeja + 99)
      },
      pripraviHistogram () {
        this.ratingHistogramX = []
        this.ratingHistogramY = []
        this.ratingHistogramBarve = []

        let spodnjaMeja = 100
        let zgornjaMeja = 1900

        for (let ratingBorder = 100; ratingBorder < 1900; ratingBorder += 100) {
          let imeSkupine = this.ratingToHistogramGroup(ratingBorder)
          if (this.histogram[imeSkupine] !== undefined) {
            if (ratingBorder < spodnjaMeja) {
              spodnjaMeja = ratingBorder
            }
            if (ratingBorder > zgornjaMeja) {
              zgornjaMeja = ratingBorder
            }
          }
        }

        let padding = Math.max((100 - (zgornjaMeja - spodnjaMeja)) / 2, 10)

        for (let ratingBorder = Math.round((spodnjaMeja - padding) / 100) * 100; ratingBorder <= zgornjaMeja + padding; ratingBorder += 100) {
          let imeSkupine = this.ratingToHistogramGroup(ratingBorder)
          this.ratingHistogramX.push(imeSkupine)
          if (this.histogram[imeSkupine] !== undefined) {
            this.ratingHistogramY.push(this.histogram[imeSkupine])
          } else {
            this.ratingHistogramY.push(0)
          }
          if (this.ratingToHistogramGroup(this.rating) === imeSkupine) {
            this.ratingHistogramBarve.push('#ca262b')
          } else {
            this.ratingHistogramBarve.push('#2872ca')
          }
        }
      },
      pripraviGraf () {
        let data = []
        this.timeAxis = []
        for (let i = 0; i < this.ratingHistory.length; i++) {
          data.push(this.ratingHistory[i].newRating)
          this.timeAxis.push((i + 1) + '')
        }
        this.grafRatinga = {labels: this.timeAxis, datasets: [{label: this.$t('pages.exams.ratingResults.rating'), fill: false, borderColor: '#2872ca', data: data}]}
        this.min = Math.min.apply(null, data) - 10
        this.max = Math.max.apply(null, data) + 10

        this.showLeaderboard()
      },
      showResultsForOneExam (attemptId) {
        if (this.dataById) {
          router.push({name: 'classExamResultsAdmin', params: {classExamId: attemptId}})
        } else {
          router.push({name: 'ratingResults', params: {sid: 'root', attemptId: attemptId}})
        }
      },
      showRatingQuizSelection () {
        this.loadingSubgroups = true
        this.subgroupArray = []
        window.jQuery('#selectSubgroupsModal').modal('toggle')
        Rest.request(`GET`, `/subgroups/` + this.gid + `/subgroupTreeRating/root`).then((data) => {
          let tabela = []
          this.treeToArray(tabela, null, data, 0)
          console.log(tabela)
          this.subgroupArray = tabela
          this.loadingSubgroups = false
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(
                ['Typeset', window.MathJax.Hub]
            )
            /* var math = window.MathJax.Hub.getAllJax('exerciseStatList')[0]
            window.MathJax.Hub.Queue(['Text', math]) */
          })
        }).catch((err) => {
          console.log(err)
          this.loadingSubgroups = false
        })
      },
      selectAllSbgroupsInTree (id, value) {
        var subgroup = this.subgroupArray.filter((s) => {
          if (s.id === id) {
            return true
          }
          return false
        })[0]

        if (value) {
          this.expandAllSubgroups(subgroup)
        } else {
          this.closeAllSubgroups(subgroup)
        }

        for (let i = 0; i < this.subgroupArray.length; i++) {
          if (this.subgroupArray[i].id === id) {
            let j = i + 1
            let nivo = this.subgroupArray[i].nivo
            while (j < this.subgroupArray.length && this.subgroupArray[j].nivo > nivo) {
              if (this.subgroupArray[j].list) {
                if (value) {
                  if (!this.izbranePodskupine.includes(this.subgroupArray[j].id)) {
                    this.izbranePodskupine.push(this.subgroupArray[j].id)
                  }
                } else {
                  let th = this
                  this.izbranePodskupine = this.izbranePodskupine.filter(function (el) {
                    return el !== th.subgroupArray[j].id
                  })
                }
              }
              j++
            }
            break
          }
        }
      },
      expandedSymbol (subgroup) {
        var children = this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              return true
            }
            return false
          }
        })

        var childrenExpanded = true
        children.forEach(element => {
          if (!element.expanded) {
            childrenExpanded = false
          }
        })

        return childrenExpanded ? '-' : '+'
      },
      closeAllSubgroups (subgroup) {
        this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              this.$set(s, 'expanded', false)
              if (s.expanded === false) {
                this.closeAllSubgroups(s)
              }
            }
          }
        })
      },
      expandAllSubgroups (subgroup) {
        var children = this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              return true
            }
            return false
          }
        })
        if (children.length > 0) {
          children.forEach(s => {
            this.$set(s, 'expanded', true)
            this.expandAllSubgroups(s)
          })
        }
      },
      toggleSubgroup  (subgroup) {
        this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              this.$set(s, 'expanded', !s.expanded)
              if (s.expanded === false) {
                this.closeAllSubgroups(s)
              }
            }
          }
        })
      },
      treeToArray (tabela, parent, drevo, nivo) {
        tabela.push({
          name: drevo.name,
          id: drevo.id,
          nivo: nivo,
          list: drevo.subgroups.length === 0,
          parent: parent,
          expanded: false
        })
        for (let i = 0; i < drevo.subgroups.length; i++) {
          var p = {
            name: drevo.name,
            id: drevo.id,
            nivo: nivo,
            list: drevo.subgroups.length === 0,
            parent: parent,
            expanded: false
          }
          this.treeToArray(tabela, p, drevo.subgroups[i], nivo + 1)
        }
      },
      startRatingQuiz () {
        let postdata = {
          subgroupIds: this.izbranePodskupine,
          testDuration: this.izbranoTrajanje,
          yearId: this.yid
        }
        Rest.request(`POST`, `/classExams/ratingQuiz`, postdata).then((data) => {
          let classExamId = data.classExamId
          Rest.request(`POST`, `/classExams/` + classExamId + `/start`, {}).then((data2) => {
            router.push({name: 'ratingExam', params: {classExamId: classExamId, sid: 'root'}})
          }).catch((err) => {
            console.log(err)
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      showLeaderboard () {
        Rest.request('GET', '/rating/leaderboard/' + this.gid).then((data) => {
          this.leaderboard = data.userRatings
          this.currentUser = this.$store.getters.getUser
          let index = this.leaderboard.map(function (e) {
            return e.username
          }).indexOf(this.currentUser.username)

          if (index === -1) {
            this.toggleLeaderboard = false
          } else if (index > 5) {
            this.leaderboard[5] = this.leaderboard[index]
            this.leaderboard[5].place = index
          }
          this.getNumberOfSolvedExercises()
          this.nalaganje = false
        })
      },
      getNumberOfSolvedExercises () {
        Rest.request(`GET`, `/rating/getSolvedExercises/` + this.currentUser.id + '/' + this.gid).then((data) => {
          this.allExercises = data.allExercises
          this.solvedExercises = data.solvedExercises
        })
      },
      showInfoModal () {
        return new Promise((resolve, reject) => {
          console.log('eee')
          this.showInfoModalBoolean = true
          resolve()
        }).then(() => {
          window.jQuery(`#${this.modalInfoKey}`).modal()
        })
      },
      getUniqueKey () { // async?
        let generated = crypto.randomBytes(20).toString('hex')
        return generated
      }
    }
  }
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.accordion-icon {
  cursor: pointer;
  margin-right: 5px; /* Add spacing between icon and text */
}

.icon-expanded::before {
  content: " - "; /* Display "-" when expanded */
}

.icon-collapsed::before {
  content: " + "; /* Display "+" when collapsed */
}

h1 {
  font-family: "Rubik", sans-serif;
  font-size: 1.7rem;
  color: #141a39;
  text-transform: uppercase;
  cursor: default;
}
#leaderboard-overlay {
  height: 20rem;
  width: 100%;
  top: 0;
  background-color: rgba(255, 255, 255, 0.9);
}
#leaderboard {
  margin-top: 5px;
  width: 100%;
  position: relative;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  color: #141a39;
  cursor: default;
}

tr {
  transition: all 0.2s ease-in-out;
  border-radius: 0.2rem;
}

tr:not(:first-child):hover {
  background-color: #fff;
  transform: scale(1);
  box-shadow: 0px 5px 15px 8px #e4e7fb;
}

tr:nth-child(odd) {
  background-color: #f9f9f9;
}

tr:nth-child(1) {
  color: #fff;
}

td {
  height: 5rem;
  font-family: "Rubik", sans-serif;
  font-size: 1.4rem;
  padding: 1rem 2rem;
  position: relative;
}

.number {
  width: 1rem;
  font-size: 2.2rem;
  font-weight: bold;
  text-align: left;
}

.name {
  text-align: left;
  font-size: 1.2rem;
}

.points {
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 5.2rem;
}

.points:first-child {
  width: 10rem;
}

.gold-medal {
  height: 3rem;
  width: 3rem;
  margin-left: 1.5rem;
  margin-right: 0;
}

.ribbon {
  width: calc(100% + 1rem);
  height: 5.5rem;
  top: -0.5rem;
  background-color: #0073b7;
  position: absolute;
  left: -0.5rem;
  -webkit-box-shadow: 0px 15px 11px -6px #7a7a7d;
  box-shadow: 0px 10px 11px -6px #a6a6a9;
}

.ribbon::before {
  content: "";
  height: 1.5rem;
  width: 1.5rem;
  bottom: -0.8rem;
  left: 0.35rem;
  transform: rotate(45deg);
  background-color: #0073b7;
  position: absolute;
  z-index: -1;
}

.ribbon::after {
  content: "";
  height: 1.5rem;
  width: 1.5rem;
  bottom: -0.8rem;
  right: 0.35rem;
  transform: rotate(45deg);
  background-color: #0073b7;
  position: absolute;
  z-index: -1;
}

@media (max-width: 740px) {
  * {
    font-size: 70%;
  }
}
@media (max-width: 500px) {
  * {
    font-size: 55%;
  }
}
@media (max-width: 390px) {
  * {
    font-size: 45%;
  }
}
.progress-leaderboard {
  position: relative;
  width: 100%;
  margin: 13px 0 7px 0;
  height: 1rem;
  background-color: #f5f5f5;
}
.progress-bar-leaderboard {
  height: 100%;
  position: absolute;
  top: 0rem;
  left: 0rem;
  background-color: #0073b7;
}
.progress-bar-eighty {
  height: 1rem;
  left: 0;
  width: 75%;
  background-color: #d0d0d0;
}
th {
  color: black;
  padding: 1rem 2rem;
  text-wrap: none;
}
</style>



// WEBPACK FOOTER //
// UserRating.vue?9912be2c